<template>
  <div id="app">
    <router-view></router-view>
    <!-- 用于渲染路由匹配的组件 -->
  </div>
</template>
<script setup>
import { postWalletLogin } from "@/config/user.js";
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";

const router = useRouter();
const isMobile = ref(false);

const mobileInfo = () => {
  const userAgent = navigator.userAgent;

  if (/Android/i.test(userAgent)) {
    return "Android";
  }

  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return "IOS";
  }

  if (/Mobi|Mobile/i.test(userAgent)) {
    return "Android";
  }
};

const checkIsMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  console.log("userAgent", userAgent);
  // 匹配常见的移动设备关键词
  if (/android|iphone|ipad|ipod|mobile/i.test(userAgent)) {
    isMobile.value = true;
  } else {
    isMobile.value = false;
  }
};
checkIsMobile();
const login = async (accounts) => {
  const queryString = window.location.search;

  // // 2. 使用 URLSearchParams 解析字符串
  const params = new URLSearchParams(queryString);

  // // 3. 使用 .get() 方法获取 'type' 参数的值
  const code = params.get("i") || "888888";
  await postWalletLogin({
    wallet: accounts,
    mobileInfo: mobileInfo(),
    parent_code: code,
  });
};
onMounted(() => {
  if (window.ethereum && isMobile.value) {
    // 钱包内置浏览器环境：
    // 1. 尝试连接钱包
    const provider = window.ethereum;

    try {
      // 请求用户授权连接钱包
      provider
        .request({ method: "eth_requestAccounts" })
        .then((accounts) => {
          // console.log("已连接钱包，账户：", accounts[0]);
          //  const cest = "0xD4e6f7D8af6bB11D2ed22865291891983F585F60"
          //  localStorage.setItem("wallet", cest);
          //  login(cest);
          //  router.push({
          //   path: "/home",
          // });
          
          if (localStorage.getItem("wallet") != accounts[0]) {
            localStorage.setItem("wallet", accounts[0]);
            login(accounts[0]);
          }
          router.push({
            path: "/home",
          });
        })
        .catch((error) => {
          console.error("连接钱包失败：", error);
          // 如果用户拒绝连接，你也可以重定向到其他页面
          // window.location.href = '/error-page';
        });
    } catch (error) {
      // 用户拒绝连接
      console.error("用户拒绝连接钱包或发生错误：", error);
      // 重定向到其他页面
    }
  } else {
    // 不在钱包内置浏览器环境：
    router.push({
      path: "/Remind",
    });
  }
});
</script>
